import { createSlice } from '@reduxjs/toolkit'
import {
  addPipeline,
  deletePipeline,
  getPipelinebyId,
  getPipelinebyMission,
  getPipelines,
  updatePipeline,
} from './pipelineActions'
import { ErreurResponse, Pipeline, PipelineResponse } from '../../types/pipelineTypes'

interface PipelineState {
  pipelines: Pipeline[]
  loading: boolean
  pipeline: Pipeline | null
  error: string | null
  addedPipeline: Pipeline | null
  updatedPipeline: Pipeline | null
  PipelineResponse: PipelineResponse | null
 ErreurResponse : ErreurResponse | null

}

const initialState: PipelineState = {
  pipelines: [],
  loading: false,
  error: null,
  addedPipeline: null,
  pipeline: null,
  updatedPipeline: null,
  PipelineResponse: null,
  ErreurResponse  : null 

}

export const pipelineSlice = createSlice({
  name: 'audit',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getPipelines.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(getPipelines.fulfilled, (state, action) => {
        state.loading = false
        state.PipelineResponse = {
          pipelines: action.payload.pipelines,
          totalPages: action.payload.totalPages ?? 0,
          total: action.payload.total ?? 0,
        }
      })
      .addCase(getPipelines.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message || 'Something went wrong'
      })
      .addCase(deletePipeline.fulfilled, (state, action) => {
        state.loading = false
        const deletedPipelineId = action.meta.arg

        if (state.PipelineResponse) {
          state.PipelineResponse.pipelines = (
            state.PipelineResponse.pipelines ?? []
          ).filter((pipeline) => pipeline._id !== deletedPipelineId)

          state.PipelineResponse.total = state.PipelineResponse.total ?? 0
          state.PipelineResponse.totalPages =
            state.PipelineResponse.totalPages ?? 0
          state.PipelineResponse.currentPage =
            state.PipelineResponse.currentPage ?? 0
        }

        
      })
      .addCase(addPipeline.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(addPipeline.fulfilled, (state, action) => {
        state.loading = false
        state.addedPipeline = action.payload
        state.pipelines.push(action.payload)
      })
      .addCase(addPipeline.rejected, (state, action) => {
        state.loading = false
        if (action.payload) {
          state.error = action.payload.message || 'An error occurred'
        } else {
          state.error = 'An unexpected error occurred'
        }
      })
      .addCase(updatePipeline.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(updatePipeline.fulfilled, (state, action) => {
        state.loading = false
        state.updatedPipeline = action.payload
      })
      .addCase(updatePipeline.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message || 'Something went wrong'
      })
      .addCase(getPipelinebyId.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(getPipelinebyId.fulfilled, (state, action) => {
        state.loading = false
        state.pipeline = action.payload
      })
      .addCase(getPipelinebyId.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message || 'Something went wrong'
      })

      .addCase(getPipelinebyMission.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(getPipelinebyMission.fulfilled, (state, action) => {
        state.loading = false
        state.PipelineResponse = {
          pipelines: action.payload.pipelines,
          totalPages: action.payload.totalPages ?? 0,
          total: action.payload.total ?? 0,
        }
      })
      .addCase(getPipelinebyMission.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message || 'Something went wrong'
      })
  },
})

export default pipelineSlice.reducer
